export abstract class QGL_Lib {
  query: <T>(query: string, register?: string) => Promise<T>;

  constructor(protected queryFunc: (query: string, register?: string) => Promise<any>) {
    this.query = queryFunc;
    return this;
  }
}
